// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'
import { ShiftsAreaId } from './ShiftsAreaId'

const baseRoute = '/shifts'

export const BaseShiftAreaRoutes = {
  title: ShiftsAreaId,
  route: baseRoute,
  ShiftOverviewDashboard: {
    route: '/overview',
    ById: {
      route: '/:shiftId',
    },
  },
  ShiftsDemandSupply: {
    route: '/supply',
  },
  ShiftsActivities: {
    route: '/activities',
  },
}

export const ShiftsAreaRoutes = transformRoutes(BaseShiftAreaRoutes)
